import { buttonNameConstants, buttonTypeConstants } from "../../../constants";
import { sidebarSelectFieldStyle } from "./sidebarSelectFieldStyle";

export const selectFieldStyle = {
  control: (base, state) => ({
    ...base,
    minHeight: "3em",
    maxHeight: "3em",
    borderRadius: "0.75em",
    boxShadow:
      "0.8px 1.6px 3.2px 0px rgba(0, 0, 0, 0.02),2.4px 4.8px 6.4px 0px rgba(0, 0, 0, 0.02),5.6px 11.2px 8px 0px rgba(0, 0, 0, 0.01)",
    backgroundColor: "#fcfafc",
    borderColor: state.isFocused ? "#6a18ed" : "transparent",
    "&:hover": {
      border: "1px solid #6a18ed",
    },
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "15em",
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#6a18ed",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: "1050",
    borderRadius: ".75em",
    overflow: "hidden",
    padding: ".75em",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: "1050",
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: "0.5em",
    marginBottom: ".25em",
    marginTop: ".25em",
    backgroundColor: state.isSelected ? "#6a18ed" : "transparent",
    color: state.isSelected ? "#fcfcfc" : "#6b6970",
    "&:hover": {
      color: "#222024",
      backgroundColor: "rgb(106, 24, 237, 0.3)",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    textWrap: "nowrap !important",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all .3s",
    color: state.isFocused ? "#6a18ed" : "#6b6970",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: "0.5",
    };
  },
};
export const selectFieldStyleSmall = {
  control: (base, state) => {
    const value = state?.getValue()[0]?.value;
    return {
      ...base,
      minHeight: "2em", // smaller height
      maxHeight: "2em",
      borderRadius: "1em", // adjust border radius proportionally
      boxShadow:
        "0.5px 1px 2px 0px rgba(0, 0, 0, 0.02), 1.5px 3px 4px 0px rgba(0, 0, 0, 0.02), 3px 6px 5px 0px rgba(0, 0, 0, 0.01)",
      backgroundColor: "#b7b5ba",
      borderColor: state.isFocused ? "#6b6970" : "transparent",
      "&:hover": {
        border: "1px solid #6b6970",
      },
      padding: "0 0.5em", // reduce padding for smaller height
      background:
        value === buttonNameConstants.COMPLETED
          ? "#4caf50"
          : value === buttonNameConstants.CANCELED
          ? "red"
          : "#2196f3",
      color: "#fff",
    };
  },
  menuList: (base) => ({
    ...base,
    maxHeight: "12em", // slightly smaller menu
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#6a18ed",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1050,
    borderRadius: "0.5em",
    overflow: "hidden",
    padding: "0.5em",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 1050,
  }),
  option: (base, state) => {
    console.log(
      "Option state:",
      state.data.value === buttonNameConstants.CANCELED
    ); // Debug log to check state values
    return {
      ...base,
      borderRadius: "0.25em",
      marginBottom: ".2em",
      marginTop: ".2em",
      padding: "0.25em 0.5em", // reduce padding for smaller field
      backgroundColor: state.isSelected ? "#6a18ed" : "transparent",
      color: state.isSelected ? "#fcfcfc" : "#6b6970",
      fontSize: "0.95rem", // slightly smaller font
      "&:hover": {
        color: "#fff",
        borderRadius: "0.8em",
        backgroundColor:
          state.data.value === buttonNameConstants.COMPLETED
            ? "#4caf50"
            : state.data.value === buttonNameConstants.CANCELED
            ? "red"
            : "#2196f3",
      },
    };
  },
  singleValue: (provided) => ({
    ...provided,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.85rem",
    color: "#fff",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all 0.3s",
    color: "#fff",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
    padding: "0 0.25em",
    "&:hover": {
      color: "#fff",
    },
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    opacity: 0.5,
    fontSize: "0.85rem",
  }),
};

export const inventoryModalPricesStatsSelectFieldStyle = {
  control: (base, state) => ({
    ...base,
    height: "3em",
    width: "14em",
    backgroundColor: "transparent",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "10em",
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#6a18ed",
    },
  }),
  menu: (base) => ({
    ...base,
    background: "#2f2f2f",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#6a18ed" : "transparent",
    color: state.isSelected ? "#fcfcfc" : "#9e9e9e",
    "&:hover": {
      color: "#fcfcfc",
      backgroundColor: "transparent",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    textWrap: "nowrap !important",
    color: "#fcfcfc",
  }),
};

export const insertVariableSelectFieldStyle = {
  ...sidebarSelectFieldStyle,
  control: (base, state) => ({
    ...sidebarSelectFieldStyle.control(base, state),
    border: "0.5px solid #915E95",
    "&:hover": {
      border: "0.5px solid #915E95",
    },
  }),
  placeholder: (defaultStyles, state) => {
    return {
      ...sidebarSelectFieldStyle.placeholder(defaultStyles, state),
      color: "#915E95",
      fontSize: "0.9em",
    };
  },
  dropdownIndicator: (base, state) => ({
    ...sidebarSelectFieldStyle.dropdownIndicator(base, state),
    color: "#915E95",
    "&:hover": {
      color: "#915E95",
    },
  }),
  menu: (base, state) => ({
    ...sidebarSelectFieldStyle.menu(base, state),
    width: "unset",
  }),
};

export const insertVariableShopifyField = {
  ...sidebarSelectFieldStyle,
  control: (base, state) => ({
    ...sidebarSelectFieldStyle.control(base, state),
    border: "0.5px solid #0062FF",
    "&:hover": {
      border: "0.5px solid #0062FF",
    },
  }),
  placeholder: (defaultStyles, state) => {
    return {
      ...sidebarSelectFieldStyle.placeholder(defaultStyles, state),
      color: "#0062FF",
      fontSize: "0.9em",
      fontStyle: "italic",
    };
  },
  dropdownIndicator: (base, state) => ({
    ...sidebarSelectFieldStyle.dropdownIndicator(base, state),
    color: "#0062FF",
    "&:hover": {
      color: "#0062FF",
    },
  }),
  menu: (base, state) => ({
    ...sidebarSelectFieldStyle.menu(base, state),
    width: "unset",
  }),
};

export const multiSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "3em",
    borderRadius: "0.75em",
    boxShadow:
      "0.8px 1.6px 3.2px 0px rgba(0, 0, 0, 0.02),2.4px 4.8px 6.4px 0px rgba(0, 0, 0, 0.02),5.6px 11.2px 8px 0px rgba(0, 0, 0, 0.01)",
    backgroundColor: "#fcfafc",
    borderColor: state.isFocused ? "#6a18ed" : "transparent",
    "&:hover": {
      border: "1px solid #6a18ed",
    },
    height: "auto",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "15em",
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#6a18ed",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: "1050",
    borderRadius: ".75em",
    overflow: "hidden",
    padding: ".75em",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: "1050",
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: "0.5em",
    marginBottom: ".25em",
    marginTop: ".25em",
    backgroundColor: state.isSelected ? "#6a18ed" : "transparent",
    color: state.isSelected ? "#fcfcfc" : "#6b6970",
    "&:hover": {
      color: "#222024",
      backgroundColor: "rgb(106, 24, 237, 0.3)",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    textWrap: "nowrap !important",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all .3s",
    color: state.isFocused ? "#6a18ed" : "#6b6970",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: "0.5",
    };
  },
};
